import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

// ------------------ COMPONENTES DE BASE--------------------------------
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

// ------------------- CONSULTAS A LA API--------------------------------
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { 
  EditarCalibre, 
  EditarEfecto, 
  EditarFibra, 
  EditarRecycled, 
  EditarType, 
  EditarTypesC, 
  GuardarCalibre, 
  GuardarEfecto, 
  GuardarFibra, 
  GuardarRecycled, 
  GuardarType, 
  GuardarTypesC 
} from "../../../API/Desarrollo/DesarrolloRequest";

const MaestrosCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
  IdCrud
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [titleAg, setTitleAg] = useState('');
  const [titleEd, setTitleEd] = useState('');

  const initialValues = {
    IdStatus: selected ? selected?.IdStatus : 66,
    Description: '',
  };


  const { values, handleInputChange, setValues, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);


    const estadosTempo = await getEstadosCategory('Yarn');
    setEstados(estadosTempo);
    const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    switch (IdCrud) {
        case 1:
            setValues({
                ...selected,
                IdCalibre: selected ? selected?.IdCalibre : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus
            });
          break;
        case 2:
            setValues({
                ...selected,
                IdType: selected ? selected?.IdType : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus
            });
          break;
        case 3:
            setValues({
                ...selected,
                IdEfecto: selected ? selected?.IdEfecto : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 4:
            setValues({
                ...selected,
                IdFibra: selected ? selected?.IdFibra : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 5:
            setValues({
                ...selected,
                IdTypeCotton: selected ? selected?.IdTypeCotton : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 6:
            setValues({
                ...selected,
                IdRecycle: selected ? selected?.IdRecycle : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus
            });
          break;
        default:
          console.warn('Invalid index for dialog');
          break;
    }
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};


    if(IdCrud === 1){
        if (!values?.CalibreInt) {
            error.CalibreInt = true;
            error.error = true;
        }
    }
    if(IdCrud === 2){
        if (!values?.Type) {
            error.Type = true;
            error.error = true;
        }
    }

    if(IdCrud === 3){
        if (!values?.Efecto) {
            error.Efecto = true;
            error.error = true;
        }
    }
    if(IdCrud === 4){
        if (!values?.Fiber) {
            error.Fiber = true;
            error.error = true;
        }
    }
    if(IdCrud === 5){
        if (!values?.TypeCotton) {
            error.TypeCotton = true;
            error.error = true;
        }
    }
    if (!values.Estado && (!values.IdStatus || !values?.Estado?.IdStatus)) {
        error.IdStatus = true;
        error.error = true;
    }

    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {

        setLoading(true);
        let respuesta
        switch (IdCrud) {
            case 1:
                const DatosCalibre = {
                    IdCalibre: values?.IdCalibre,
                    CalibreInt: values?.CalibreInt,
                    Calibre: (values?.CalibreInt)?.toString(),
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser,
                };
                if(DatosCalibre?.IdCalibre > 0){
                    respuesta = await EditarCalibre(DatosCalibre)
                }else{
                    respuesta = await GuardarCalibre(DatosCalibre)
                }

              break;
            case 2:
                const DatosType = {
                    IdType: values?.IdType,
                    Type: values?.Type,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser,
                };

                if(DatosType?.IdType > 0){
                    respuesta = await EditarType(DatosType)
                }else{
                    respuesta = await GuardarType(DatosType)
                }
              break;
            case 3:
                const DatosEfecto = {
                    IdEfecto: values?.IdEfecto,
                    Efecto: values?.Efecto,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser,
                };

                if(DatosEfecto?.IdEfecto > 0){
                    respuesta = await EditarEfecto(DatosEfecto)
                }else{
                    respuesta = await GuardarEfecto(DatosEfecto)
                }
              break;
            case 4:
                const DatosFibra = {
                    IdFibra: values?.IdFibra,
                    Fiber: values?.Fiber,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser,
                };

                if(DatosFibra?.IdFibra > 0){
                    respuesta = await EditarFibra(DatosFibra)
                }else{
                    respuesta = await GuardarFibra(DatosFibra)
                }
              break;
            case 5:
                const DatosTypesC = {
                    IdTypeCotton: values?.IdTypeCotton,
                    TypeCotton: values?.TypeCotton,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser,
                };

                if(DatosTypesC?.IdTypeCotton > 0){
                    respuesta = await EditarTypesC(DatosTypesC)
                }else{
                    respuesta = await GuardarTypesC(DatosTypesC)
                }
              break;
            case 6:
                const DatosRecycled = {
                    IdRecycle: values?.IdRecycle,
                    Recycled: values?.Recycled,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.IdUser,
                    IdUserEdit: userAuth?.IdUser
                };
                
                if(DatosRecycled?.IdRecycle > 0){
                    respuesta = await EditarRecycled(DatosRecycled)
                }else{
                    respuesta = await GuardarRecycled(DatosRecycled)
                }
              break;
            default:
              console.warn('Invalid index for dialog');
              break;
        }

        if (respuesta[0].ESTADO !== -1) {
            toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
            setTimeout(() => {
              onHide();
              setLoading(false);
              getInfo();
            }, 1500);
        } else {
            toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
            setLoading(false);
        }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
        switch (IdCrud) {
            case 1:
              setTitleAg(getLabel(baseLang, "Agregar Calibre", config.language))
              setTitleEd(getLabel(baseLang, "Editar Calibre", config.language))
              break;
            case 2:
                setTitleAg(getLabel(baseLang, "Agregar Spinning", config.language))
                setTitleEd(getLabel(baseLang, "Editar Spinning", config.language))
              break;
            case 3:
                setTitleEd(getLabel(baseLang, "Editar Efecto", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Efecto", config.language))
              break;
            case 4:
                setTitleEd(getLabel(baseLang, "Editar Fibra", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Fibra", config.language))
              break;
            case 5:
                setTitleEd(getLabel(baseLang, "Editar Composición de Algodón", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Composición de Algodón", config.language))
              break;
            case 6:
                setTitleEd(getLabel(baseLang, "Editar Reciclado", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Reciclado", config.language))
              break;
            default:
              console.warn('Invalid index for dialog');
              break;
        }
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? titleAg : titleEd;

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
            <div className="d-flex align-items-center mx-5">
                <h2>{dialogTitle}</h2>
            </div>

            {IdCrud === 1 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputNumber
                                    name="CalibreInt"
                                    value={values?.CalibreInt}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.CalibreInt ? "p-invalid" : ""}
                                />
                                <label htmlFor="CalibreInt">{getLabel(baseLang, "Calibre", config.language)}</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>

                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 2 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Type"
                                    value={values.Type}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Type ? "p-invalid" : ""}
                                />
                                <label htmlFor="Type">Spinning</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Description"
                                    value={values.Description}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Description ? "p-invalid" : ""}
                                />
                                <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>


                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 3 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Efecto"
                                    value={values.Efecto}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Efecto ? "p-invalid" : ""}
                                />
                                <label htmlFor="Efecto">Efecto</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Description"
                                    value={values.Description}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Description ? "p-invalid" : ""}
                                />
                                <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>

                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 4 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Fiber"
                                    value={values?.Fiber}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Fiber ? "p-invalid" : ""}
                                />
                                <label htmlFor="Fiber">Fibra</label>
                            </span>
                        </div>

                        
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Description"
                                    value={values.Description}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Description ? "p-invalid" : ""}
                                />
                                <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>

                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 5 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="TypeCotton"
                                    value={values?.TypeCotton}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.TypeCotton ? "p-invalid" : ""}
                                />
                                <label htmlFor="TypeCotton">{getLabel(baseLang, "Composición", config.language)}</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Description"
                                    value={values.Description}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Description ? "p-invalid" : ""}
                                />
                                <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>

                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 6 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Recycled"
                                    value={values?.Recycled}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Recycled ? "p-invalid" : ""}
                                />
                                <label htmlFor="Recycled">{getLabel(baseLang, "Recycled", config.language)}</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Description"
                                    value={values.Description}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Description ? "p-invalid" : ""}
                                />
                                <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>


                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

        </div>
      </Dialog>
    </div>
  );
};

export default MaestrosCRUD;
